import { PERIODS, SKUS } from '@/modules/usage/constants/countables';

const row = (key, period, credit, usage, resetsAt = null) => ({
  key: `${SKUS.SMS}-${key}`,
  period,
  unlimited: false,
  consumed: usage,
  credit,
  left: Math.max(credit - usage, 0),
  resetsAt,
  expiresAt: null,
});

export const toUsageRows = (smsQuotas) => {
  if (!smsQuotas) return [];

  const monthlyCredit = smsQuotas.sms_monthly_credit || 0;
  const oneTimeCredit = smsQuotas.sms_credit || 0;
  const rows = [];

  if (monthlyCredit > 0) {
    rows.push(row(
      'monthly',
      PERIODS.MONTHLY,
      monthlyCredit,
      smsQuotas.sms_monthly_usage || 0,
      smsQuotas.sms_monthly_reset_at || null,
    ));
  }

  if (oneTimeCredit > 0) {
    rows.push(row('one-time', PERIODS.LIFE_LONG, oneTimeCredit, smsQuotas.sms_usage || 0));
  }

  return rows;
};

export const fromBalance = (balance) => {
  if (typeof balance !== 'number') return [];

  return [{
    key: `${SKUS.SMS}-balance`,
    period: PERIODS.BALANCE,
    unlimited: false,
    consumed: null,
    credit: null,
    left: balance,
    resetsAt: null,
    expiresAt: null,
  }];
};

export default { toUsageRows, fromBalance };
